import {createSelector} from 'reselect';
import props from '../../../../props';
import { float } from '../../../../../utils/formats';

export default createSelector(
    props.wallet.methods.chime_cashout,
    props.user.user,
    (chime_cashout, user) => {
        return {
            props: chime_cashout[chime_cashout.stage],
            user,
            available_balance: user ? float(user.balance - user.wager) : 0
        }
    }
)